export default __webpack_public_path__ + "static/media/pencil.af5bf956.svg";